// extracted by mini-css-extract-plugin
export var cardLayout = "_71-1";
export var paginationContainer = "_71-0";